import React, { useEffect, useRef, useState } from "react";
import { object, array, number, string } from "prop-types";
import { formatStoryDate } from "../../helper/utils";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import { useSelector } from "react-redux";
import { get } from "lodash";
import "./bookmark-story-card.m.css";
import FillBookmark from "../../atoms/other-icons/FillBookmark";

const BookmarkStoryCard = ({ story, aspectRatio, imageType, headerType, headerLevel, addBookmark, removeBookmark }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const [tip, setTip] = useState("");

  const publishedDate = formatStoryDate(story["published-at"]);

  const isAlreadyBookmarked = userdetails?.metadata?.savedArticles?.some((article) => article.id === story.id);

  useEffect(() => {
    if (isAlreadyBookmarked) {
      setIsBookmarked(true);
    }
  }, [isAlreadyBookmarked]);

  const addBookmarkHandler = () => {
    addBookmark(story);
    setIsBookmarked(true);
    setTip("Added to Bookmarks");
  };
  const removeBookmarkHandler = () => {
    removeBookmark(story);

    setIsBookmarked(false);
    setTip("Removed from Bookmarks");
  };

  return (
    <div className="bookmark-card" styleName="bookmark-story-card">
      <Link href={`/${story.slug}`}>
        <div styleName="card-wrapper">
          <Headline text={story.headline} headerType={headerType} headerLevel={headerLevel} story={story} />
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[720]}
            showVideoIcon={story["story-template"] === "video"}
            showCameraIcon={story["story-template"] === "photo"}
          />
        </div>
        <div styleName="date">{publishedDate} IST</div>
      </Link>
      <div styleName="timestamp">
        <div styleName="bookmark-icon-wrapper">
          {isBookmarked ? (
            <>
              <button styleName="bookmark-icon" onClick={removeBookmarkHandler}>
                <FillBookmark color="black" width="18" height="18" />
              </button>
              <span>{tip}</span>
            </>
          ) : (
            <>
              <button styleName="bookmark-icon" onClick={addBookmarkHandler}>
                <FillBookmark color="#eee" width="18" height="18" />
              </button>
              <span>{tip}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

BookmarkStoryCard.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2
};

BookmarkStoryCard.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number
};

export default BookmarkStoryCard;
